import { render, staticRenderFns } from "./EmployeesItem.vue?vue&type=template&id=68a74a4d&"
import script from "./EmployeesItem.vue?vue&type=script&lang=js&"
export * from "./EmployeesItem.vue?vue&type=script&lang=js&"
import style0 from "./EmployeesItem.vue?vue&type=style&index=0&id=68a74a4d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports